import { CustomRecentInputKeys } from '@shared/forms/custom-recent-input/data/custom-recent-input-keys.directory';

export type RecentInputState = {
  all: Partial<Record<CustomRecentInputKeys, Array<string>>>;
};
export const recentInputInitialState: RecentInputState = {
  all: {},
};
